<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div class="d-flex justify-content-between align-items-center">
            <h4>Mô hình tổ chức</h4>
            <el-button class="btn-back" @click="fn_goBack">Quay lại</el-button>
          </div>
          <div class="main-body mt-2">
            <div class="main-body-search">
              <!-- Thêm mới mô hình tổ chức -->
              <el-card class="box-card mb-3">
                <el-form
                  ref="formCreateDocumentOrganization"
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  @submit.native.prevent
                  label-width="172px"
                >
                  <b-row class="mb-3">
                    <h5>Thêm mới mô hình tổ chức</h5>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Tên mô hình tổ chức" prop="name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.name"
                          placeholder=""
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Đơn vị cha">
                        <el-select
                          v-model="mData.dataForm.parent_id"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="item in viewMode == 'update'
                              ? mData.listParentOrganizationUpdate
                              : mData.listParentOrganization"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Thứ tự hiển thị" prop="order">
                        <el-input-number
                          v-model.trim="mData.dataForm.order"
                          placeholder=""
                          clearable
                          :min="1"
                          controls-position="right"
                        ></el-input-number>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Nhân viên" prop="">
                        <el-select
                          v-model="mData.dataForm.employee_ids"
                          multiple
                          placeholder="Chọn"
                          class="multi-select"
                          size="large"
                          filterable
                        >
                          <el-option
                            v-for="emp in mData.listEmployee"
                            :key="emp.id"
                            :label="
                              `${
                                emp && emp.employee_no ? emp.employee_no : ''
                              } - ${
                                emp && emp.administrative_info.name.full_name
                                  ? emp.administrative_info.name.full_name
                                  : ''
                              }`
                            "
                            :value="emp.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <div class="text-center mb-0">
                    <el-button
                      v-if="viewMode == 'create'"
                      class="btn-default"
                      @click="fn_submitForm('create')"
                      >Lưu</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-default"
                      @click="fn_submitForm('update')"
                      >Cập nhật</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-back"
                      @click="fn_cancelUpdate()"
                      >Hủy</el-button
                    >
                  </div>
                </el-form>
              </el-card>
              <!-- Start Table -->
              <h5 class="mb-1">Danh mục mô hình tổ chức</h5>
              <div class="main-body-table">
                <el-table
                  :data="mData.tableRules.data"
                  :border="true"
                  style="width: 100%"
                >
                  <el-table-column prop="" label="STT" width="45">
                    <template slot-scope="scope">
                      <div class="text-center">
                        {{ mData.tableRules.offset + scope.$index + 1 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Tên tổ chức"
                    min-width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="parent_name"
                    label="Đơn vị cha"
                    align="center"
                    min-width="110"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.parent_name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.parent_name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="Thao tác" align="center" width="200">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('update', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_update"
                        type="primary"
                        :disabled="scope.row.is_default"
                      >
                        <i class="far fa-edit"></i>
                      </el-button>
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('delete', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_delete"
                        type="danger"
                        :disabled="scope.row.is_default"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                  <div class="col-md-4"></div>
                  <div class="col-md-8 text-right">
                    <el-pagination
                      @size-change="fn_tableSizeChange"
                      @current-change="fn_tableCurentChange"
                      @prev-click="fn_tablePrevClick"
                      @next-click="fn_tableNextClick"
                      :page-sizes="mData.tableRules.lengthMenu"
                      :page-size="mData.tableRules.limit"
                      :current-page="mData.tableRules.page"
                      background
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="mData.tableRules.total"
                      :pager-count="5"
                    ></el-pagination>
                  </div>
                </b-row>
              </div>
              <!-- End Table -->
              <!-- Start Tree OrganizationModel -->
              <h5 class="mb-1">Cây mô hình tổ chức</h5>
              <el-card class="box-card mb-3">
                <el-tree
                  :data="mData.dataDefault.listOrganizationModelTree"
                  default-expand-all
                  node-key="id"
                  ref="tree"
                  highlight-current
                  icon-class=""
                  :props="defaultProps"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>
                      {{ node.label }}
                    </span>
                  </span>
                </el-tree>
              </el-card>
              <!-- End Tree OrganizationModel -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService'
import MethodService from '../../../service/MethodService'
import CategoryManagementModel from './CategoryManagementModel'
import OrganizationModelApi from '../../../moduleApi/OrganizationModelApi'
import BranchApi from '../../../moduleApi/BranchApi'
import DepartmentApi from '../../../moduleApi/DepartmentApi'
import PositionApi from '../../../moduleApi/PositionApi'
import EmployeeApi from '../../../moduleApi/EmployeeApi'
import _ from 'lodash'
import { dataMixin } from './mixin/dataMixin'
import { functionMixin } from './mixin/functionMixin'

export default {
  mixins: [dataMixin, functionMixin],
  data() {
    return {
      aLang: LanguageService.lang,
      currentUser: MethodService.getCurrentUser(),
      currentCompany: MethodService.getCompanyInfo(),
      viewMode: 'create',
      order: 1,
      target_id: '',
      visibleParentSelectbox: false,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      mData: {
        moduleName: 'DocumentOrganizationModel',
        tableRules: MethodService.copyObject(
          CategoryManagementModel.tableRules
        ),
        dataForm: MethodService.copyObject(
          CategoryManagementModel.dataFormOrganizationModel
        ),
        validForm: CategoryManagementModel.validFormOrganizationModel,
        dataDefault: {
          listOrganizationModelTree: [],
          listEmployeeInOrganizationModel: [],
        },
        listType: [
          {
            label: 'Chi nhánh',
            value: 'BRANCH',
          },
          {
            label: 'Phòng ban',
            value: 'DEPARTMENT',
          },
          {
            label: 'Chức vụ',
            value: 'POSITION',
          },
          {
            label: 'Nhân viên',
            value: 'EMPLOYEE',
          },
          {
            label: 'Khác',
            value: 'OTHER',
          },
        ],
        listRespectivelyData: [],
        listDepartment: [],
        listPosition: [],
        listBranch: [],
        listEmployee: [],
        listParentOrganization: [],
        listParentOrganizationUpdate: [],
      },
    }
  },
  methods: {
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      }

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit
        dataFilter.page = this.mData.tableRules.page
        dataFilter.offset = this.mData.tableRules.offset
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: 'Admin-CategoryManagement-' + this.mData.moduleName,
            query: {
              ...dataFilter,
            },
          })
          .catch((err) => {})
      }
      const documentCategoryApiRes = await OrganizationModelApi.list(
        dataFilter
      )
      this.mData.tableRules.total = documentCategoryApiRes.meta.total
      if (
        documentCategoryApiRes.result &&
        documentCategoryApiRes.result.length > 0
      ) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1
        this.mData.tableRules.data = await this.fn_matchData(
          documentCategoryApiRes.result
        )
        // console.log('this.mData.tableRules.data', this.mData.tableRules.data)
      } else {
        this.mData.tableRules.data = []
      }
      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit
        await this.fn_initTable()
      }
    },

    async fn_getDataById(id) {
      const documentCategoryApiRes = await OrganizationModelApi.findById(id)
      if (documentCategoryApiRes.result) {
        return documentCategoryApiRes.result
      }
    },

    async fn_getListOrganizationModel() {
      const organizationModelApiRes = await OrganizationModelApi.list({
        limit: 9999,
      })
      if (organizationModelApiRes.result) {
        const result = organizationModelApiRes.result
        this.mData.listParentOrganization = []
        let checkHaveCurrentCompany = result.find((item) => {
          return item.id == this.currentCompany.id
        })
        if (checkHaveCurrentCompany) {
          this.mData.listParentOrganization = result
        } else {
          this.mData.listParentOrganization = [
            {
              id: this.currentCompany.id,
              name: this.currentCompany.name.name_vi,
            },
            ...result,
          ]
        }
      }
    },

    async fn_getListDepartment() {
      const departmentApiRes = await DepartmentApi.list({ limit: 9999 })
      if (departmentApiRes.result) {
        this.mData.listDepartment = departmentApiRes.result
      }
    },

    async fn_getListPosition() {
      const positionApiRes = await PositionApi.list({ limit: 9999 })
      if (positionApiRes.result) {
        this.mData.listPosition = positionApiRes.result
      }
    },

    async fn_getListBranch() {
      const branchApiRes = await BranchApi.list({ limit: 9999 })
      if (branchApiRes.result) {
        this.mData.listBranch = branchApiRes.result
      }
    },

    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        fields: 'id,employee_no,administrative_info,status,disabled',
        filters: 'disabled=false&status=DANG_LAM_VIEC&disabled=false',
        limit: 9999,
      })
      if (employeeApiRes.result) {
        this.mData.listEmployee = employeeApiRes.result
      }
    },

    async fn_getRespectivelyData(type, resData) {
      let res = []
      this.mData.listRespectivelyData = []
      if (this.mData.dataForm.target_id) this.mData.dataForm.target_id = null
      if (type == 'DEPARTMENT') {
        res = await DepartmentApi.list({ fields: 'id,name', limit: 9999 })
        this.mData.listRespectivelyData = await this.fn_changeData(res.result)
      } else if (type == 'BRANCH') {
        res = await BranchApi.list({ fields: 'id,name', limit: 9999 })
        this.mData.listRespectivelyData = await this.fn_changeData(res.result)
      } else if (type == 'POSITION') {
        res = await PositionApi.list({ fields: 'id,name', limit: 9999 })
        this.mData.listRespectivelyData = await this.fn_changeData(res.result)
      } else if (type == 'EMPLOYEE') {
        res = await EmployeeApi.list({
          fields: 'id,administrative_info,employee_no',
          limit: 9999,
        })
        this.mData.listRespectivelyData = await this.fn_changeData(res.result)
      }
      if (resData) {
        this.mData.dataForm = resData
      }
    },

    fn_changeData(data) {
      data.forEach((item) => {
        if (item.name) {
          item.label = item.name
        }
        if (item.administrative_info) {
          item.label =
            item.employee_no + ' - ' + item.administrative_info.name.full_name
        }
      })
      return data
    },

    fn_matchData(data) {
      data.forEach((item) => {
        item.name = item.name ? item.name : '-'
        if (item.parent_id) {
          const o = this.mData.listParentOrganization.find(
            (o) => o.id == item.parent_id
          )
          item.parent_name = o ? o.name : '-'
        }
      })
      return data
    },

    async fn_initTableDefault() {
      // await this.fn_getListDepartment()
      // await this.fn_getListPosition()
      // await this.fn_getListBranch()
      await this.fn_getListEmployee()
      this.fn_getListOrganizationModel()
    },

    fn_submitForm(type) {
      this.$refs['formCreateDocumentOrganization'].validate(async (valid) => {
        if (valid) {
          try {
            this.mData.dataForm.parent_id = this.mData.dataForm.parent_id
              ? this.mData.dataForm.parent_id
              : this.currentCompany.id
            this.mData.dataForm.order = this.mData.dataForm.order
              ? this.mData.dataForm.order
              : 1
            if (type == 'create') {
              // console.log(this.mData.dataForm)
              await OrganizationModelApi.create(this.mData.dataForm)
            } else if (type == 'update') {
              await OrganizationModelApi.update(this.mData.dataForm)
            }
            await this.fn_initTable()
            await this.fn_getListOrganizationModelTree()
            await this.fn_getListOrganizationModel()
            this.fn_resetForm()
            this.viewMode = 'create'
          } catch (error) {
            if (error.code == 500) {
              this.$refs.name.focus()
              window.toastr.error('Mô hình tổ chức đã tồn tại')
            }
          }
        } else {
          MethodService.stopLadda()
          return false
        }
      })
    },

    async fn_handle(type, scope, row) {
      if (type == 'update') {
        this.mData.listParentOrganizationUpdate =
          this.mData.listParentOrganization.filter((el) => el.id !== row.id)
        // console.log(
        //   'this.mData.listParentOrganizationUpdate',
        //   this.mData.listParentOrganizationUpdate
        // )
        this.viewMode = 'update'
        this.fn_resetForm()
        const res = await this.fn_getDataById(row.id)
        await this.fn_getRespectivelyData(res.type, res)
        this.target_id = this.mData.dataForm.target_id
      } else if (type == 'delete') {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: 'warning',
        })
          .then(() => {
            this.fn_delete(row.id)
          })
          .catch(() => {})
      }
    },

    async fn_delete(id) {
      try {
        await OrganizationModelApi.delete(id)
        await this.fn_initTable()
        await this.fn_getListOrganizationModelTree()
        await this.fn_getListOrganizationModel()
      } catch (error) {
        if (error.message) {
          window.toastr.error(error.message)
        } else {
          window.toastr.error('Xóa mô hình tổ chức thất bại')
        }
      }
    },

    async fn_getListOrganizationModelTree() {
      const organizationApiRes = await OrganizationModelApi.list({
        limit: 9999,
      })
      if (organizationApiRes.result) {
        let result = organizationApiRes.result
        let arrEmpIds = []
        result.forEach((item) => {
          if (item.employee_ids) arrEmpIds = arrEmpIds.concat(item.employee_ids)
        })
        arrEmpIds = _.uniq(arrEmpIds)
        await this.getListEmployeeInOrganizationModel(arrEmpIds)
        let treeList = []
        // Get all parent
        let parents = result.filter((r) => {
          return r.parent_id == null
        })
        if (parents != null && parents.length > 0) {
          parents.forEach((organization1) => {
            let obj = {
              id: organization1.id,
              label: organization1.name ? organization1.name : 'Tổ chức không xác định',
              children: [],
            }
            if (organization1.employee_ids && organization1.employee_ids.length > 0) {
              organization1.employee_ids.forEach((empId) => {
                const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                  (e) => e.id == empId
                )
                if (emp) {
                  obj.children.push({
                    // id: emp.id,
                    label: emp.administrative_info.name.full_name,
                    type: 'employee',
                    order: 1,
                    children: [],
                  })
                }
              })
            }
            // Get child of parent
            const childs = result.filter((r) => r.parent_id == obj.id)
            if (childs != null && childs.length > 0) {
              childs.forEach((element) => {
                obj.children.push({
                  id: element.id,
                  label: element.name ? element.name : 'Tổ chức không xác định',
                  order: element.order,
                  type: 'organization',
                  children: this.fn_getTreeByRecursion(element, result),
                })
                if (element.employee_ids && element.employee_ids.length > 0) {
                  element.employee_ids.forEach((empId) => {
                    const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                      (e) => e.id == empId
                    )
                    if (emp) {
                      let updateChild = obj.children.find(e => e.id == element.id)
                      updateChild.children.push({
                        employee_id: emp.id,
                        label: emp.administrative_info.name.full_name,
                        type: 'employee',
                        order: 1,
                        children: [],
                      })
                    }
                  })
                }
              })
              obj.children = obj.children.sort((a, b) => a.order - b.order)
            }
            treeList.push(obj)
          })
        }
        this.mData.dataDefault.listOrganizationModelTree = treeList
        // console.log('DATA', treeList)
      }
    },

    fn_getTreeByRecursion(child, rootArr) {
      let childrenArr = rootArr.filter((r) => r.parent_id == child.id)
      if (!childrenArr || childrenArr.length == 0) return []
      let root = childrenArr.map((organization1) => {
        let obj = {
          id: organization1.id,
          type: 'organization',
          label: organization1.name ? organization1.name : 'Không xác định',
          order: organization1.order,
          children: [],
        }
        ////////////////////////////////
        obj.children = this.fn_getTreeByRecursion(organization1, rootArr)
        if (organization1.employee_ids && organization1.employee_ids.length > 0) {
          organization1.employee_ids.forEach((empId) => {
            const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find((e) => e.id == empId)
            if (emp) {
              obj.children.push({
                employee_id: emp.id,
                type: 'employee',
                label: emp.administrative_info.name.full_name,
                order: 1,
                children: [],
              })
            }
          })
        }
        return obj
      })
      return root.sort((a, b) => a.order - b.order)
    },

    async getListEmployeeInOrganizationModel(arrIds) {
      const employeeApiRes = await EmployeeApi.list({
        fields: 'id,administrative_info',
        limit: arrIds.length,
        filters: `id:in:${arrIds.join(',')}`,
      })
      this.mData.dataDefault.listEmployeeInOrganizationModel = employeeApiRes.result
    },

    fn_cancelUpdate() {
      this.fn_resetForm()
      this.viewMode = 'create'
    },

    fn_resetForm() {
      (this.mData.dataForm = MethodService.copyObject(
        CategoryManagementModel.dataFormOrganizationModel
      )),
        this.$refs['formCreateDocumentOrganization'].resetFields()
      this.mData.listRespectivelyData.length = 0
    },

    forceUpdateUI() {
      this.$forceUpdate()
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit
      this.fn_tableChangeOffset(1)
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page)
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page)
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page)
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit
      this.fn_initTable()
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit)
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page)
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort
        if (this.mData.tableRules.sort.indexOf('-') != -1) {
          this.mData.tableRules.defaultSort[1] = 'descending'
        } else {
          this.mData.tableRules.defaultSort[1] = 'ascending'
        }
      }

      if (this.$route.query.showFormSearch == 'true') {
        this.mData.tableRules.showFormSearch = true
      }
      if (this.$route.query.showFormSearch == 'false') {
        this.mData.tableRules.showFormSearch = false
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        )
      }
    },

    fn_goBack() {
      this.$router.go(-1)
    },
  },
  async created() {
    this.mData.dataForm.type = 'ORGANIZATION'
    await this.fn_hashUrl()
    await this.fn_initTableDefault()
    await this.fn_initTable()
    this.fn_getListOrganizationModelTree()
    this.changeBreadCrumb('DocumentOrganizationModel')
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
::v-deep .el-radio {
  margin-right: 32px;
}
</style>
